import i18nFactory from '@yandex-int/i18n';
import { KeyboardEvent } from 'react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { KeyCode } from '../../../typings/common';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';

import './PhrasesSelectorMinusPhrasesAddForm.css';
import * as keyset from './PhrasesSelectorMinusPhrasesAddForm.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasesSelectorMinusPhrasesAddFormProps {
    onAdd: (phrase: string) => void;
}

interface PhrasesSelectorMinusPhrasesAddFormState {
    value: string;
}

const BLOCK = 'phrases-selector-minus-phrases-add-form';

export class PhrasesSelectorMinusPhrasesAddForm extends React.PureComponent<
    PhrasesSelectorMinusPhrasesAddFormProps,
    PhrasesSelectorMinusPhrasesAddFormState
> {
    state = {
        value: ''
    };

    render() {
        const { value } = this.state;

        return (
            <div className={Bem.cls(BLOCK)}>
                <TextInputDecorator
                    cls={Bem.cls(BLOCK, 'input')}
                    text={value}
                    theme="normal"
                    view="classic"
                    size="m"
                    placeholder={i18n('placeholder')}
                    onChange={this.onChange}
                    onKeyDown={this.onInputKeydown}
                />
            </div>
        );
    }

    private onChange = (value: string) => {
        this.setState({ value });
    };

    private onInputKeydown = (event: KeyboardEvent<HTMLElement>) => {
        const { value } = this.state;
        const { onAdd } = this.props;

        if (event.keyCode !== KeyCode.RETURN || !value) {
            return;
        }

        this.setState({ value: '' });

        onAdd(value);
    };
}
